import i18n from '@shared/i18n'

import { ApiErrorCode } from '@protots/api_error_code'

export const errorCodesMapper = {
  [ApiErrorCode.GS_CANNOT_REMOVE_LAST_OWNER]: i18n.global.t(
    'codeErrors.GS_CANNOT_REMOVE_LAST_OWNER'
  ),
  [ApiErrorCode.GS_CANNOT_SELF_REMOVE_LAST_GROUP]: i18n.global.t(
    'codeErrors.GS_CANNOT_SELF_REMOVE_LAST_GROUP'
  ),
  [ApiErrorCode.PC_UNKNOWN_PATIENT]: i18n.global.t(
    'codeErrors.PC_UNKNOWN_PATIENT'
  ),
  [ApiErrorCode.SS_RESOURSE_NAME_ALREADY_TAKEN]: i18n.global.t(
    'codeErrors.SS_RESOURSE_NAME_ALREADY_TAKEN'
  ),
  [ApiErrorCode.CC_SFTP_CONFIG_IS_NOT_ACTIVE]: i18n.global.t(
    'codeErrors.CC_SFTP_CONFIG_IS_NOT_ACTIVE'
  ),
  [ApiErrorCode.CC_NO_SFTP_SOURCE_IS_CONFIGURED]: i18n.global.t(
    'codeErrors.CC_NO_SFTP_SOURCE_IS_CONFIGURED'
  ),
  [ApiErrorCode.CC_NO_SFTP_RECIPIENT_SOURCE_IS_CONFIGURED]: i18n.global.t(
    'codeErrors.CC_NO_SFTP_RECIPIENT_SOURCE_IS_CONFIGURED'
  ),
  [ApiErrorCode.SA_CANNOT_REMOVE_LAST_SUPEROWNER]: i18n.global.t(
    'codeErrors.SA_CANNOT_REMOVE_LAST_SUPEROWNER'
  ),
  [ApiErrorCode.PC_CANNOT_CONTINUE_AUTO_CAMPAIGN_CONVERSATION]: i18n.global.t(
    'codeErrors.PC_CANNOT_CONTINUE_AUTO_CAMPAIGN_CONVERSATION'
  ),
  [ApiErrorCode.CC_AUTO_CAMPAIGN_IS_EXPIRED]: i18n.global.t(
    'codeErrors.PC_CANNOT_CONTINUE_AUTO_CAMPAIGN_CONVERSATION'
  ),
} as Record<number, string>
